const Wall = require("../../lib/Wall")
const Hand = require("../../lib/Hand")
const Tile = require("../../lib/Tile")
const Match = require("../../lib/Match")
const Pretty = require("../../lib/Pretty")
const Sequence = require("../../lib/Sequence")
const TileContainer = require("../../lib/TileContainer")
const localizeTileName = require("./../localizeJustInTime.js").localizeTileName

const {phraseTimeDuration} = require("./../phraseTimeDelta.js")

const {i18n} = require("../../lib/i18nHelper.js")

//Note that these native modules will be empty objects in the browser!
const path = require("path")
const fs = require("fs")

const alphanumeric = /^[\p{Letter}\p{Number} ]*$/u; //Checks for ALL alphanumeric, 0 or more

let baddies = `\\/:*?"<>|'&`
for (let char of baddies) {
	//This code should never run. It is purely present to ensure that, if the Regexp
	//is changed to support emojis, etc, that it does not allow for XSS attacks. 
	if (alphanumeric.test(char)) {throw "Disallowed character passed Regexp test"}
}


class Room {
	constructor(roomId, state = {}) {
		if (roomId.length === 0) {
			throw new Error("Room ID too short. ")
		}
		if (roomId.match(alphanumeric) === null) {
			throw new Error("Room ID not allowed. Please use alphanumeric characters. ")
		}

		this.activityOccured()
		//Note: If loading from state, this.init() must be called.
		this.state = state
		this.roomId = this.state.roomId = roomId
		this.state.settings = this.state.settings || {}

		console.log(state)
		//TODO: Currently, clientId of other users in the same room can be found in DevTools, allowing for impersonation. This needs to be fixed by using different identifiers internally and externally, or with auth.

		this.clientIds = this.state.clientIds = this.state.clientIds || []

		//Copy nicknames using setClientNickname, to avoid attacks with malicious nicknames in save files. 
		let tempNicknames = this.state.clientNicknames || {}
		this.clientNicknames = this.state.clientNicknames = {} //We modify this.state.clientNicknames by reference to this.clientNicknames, so they are the same. 

		for (let clientId in tempNicknames) {
			this.setClientNickname(clientId, tempNicknames[clientId])
		}

		this.inGame = false
		this.gameData = {}

		this.setInstructions = (function(clientId, instructions) {
			let client = globalThis.serverStateManager.getClient(clientId)
			client.setInstructions(instructions)
		}).bind(this)

		this.setAllInstructions = (function(excludeClientIds, instructions) {
			this.clientIds.forEach((clientId) => {
				if (!excludeClientIds.includes(clientId)) {
					let client = globalThis.serverStateManager.getClient(clientId)
					client.setInstructions(instructions)
				}
			})
		}).bind(this)


		let _hostClientId;
		Object.defineProperty(this, "hostClientId", {
			set: function(id) {
				_hostClientId = id
				this.state.hostClientId = id
			},
			get: function() {return _hostClientId}
		})
		this.hostClientId = this.state.hostClientId

		this.state.moves = this.state.moves || []


		let loadState = (function loadState() {
			console.time("Loading Room State... ")

			//Make sure we don't blast all the clients with repeat messages.
			for (let clientId of this.clientIds) {
				let client = globalThis.serverStateManager.getClient(clientId)
				if (!client) {
					//If the client/bot does not exist, create it.
					if (clientId.startsWith("bot")) {
						client = globalThis.serverStateManager.createBot(clientId)
					}
					else {
						client = globalThis.serverStateManager.createClient(clientId)
					}
				}
				client.suppress()
				if (client.getRoomId() === undefined) {client.setRoomId(this.roomId)}
			}


			if (this.state.seed) {
				//We can only replay moves if there is a seed. 
				console.warn(this.clientIds)

				//Replay moves.
				let _moves = this.state.moves.slice(0)

				this.startGame({type: "roomActionStartGame", settings: this.state.settings})

				_moves.forEach((move) => {
					this.onPlace(...move)
				})
			}

			//Unsuppress clients. 
			this.clientIds.forEach((clientId) => {
				globalThis.serverStateManager.getClient(clientId).unsuppress()
			})

			this.sendStateToClients()
			delete this.init
			console.timeEnd("Loading Room State... ")
		}).bind(this)

		this.init = loadState

		this.startGame = (require("./startGame.js")).bind(this)
		this.addBot = (require("./addBot.js")).bind(this)

		//Directs incoming message to the proper handlers, in some cases applying checks.
		this.onIncomingMessage = (require("./onIncomingMessage.js")).bind(this)

		//Generates summary for game end.
		this.getSummary = (require("./getSummary.js")).bind(this)

		this.turnChoicesProxyHandler = {
			set: (require("./turnChoicesProxyHandler.js")).bind(this)
		}

		//Creates state visible to a specific client. Used by room.sendStateToClients
		this.getState = (require("./getState.js")).bind(this)

		//For kicking players and leaving the room.
		this.removeClient = (require("./removeClient.js")).bind(this)

		this.drawTile = (require("./drawTile.js")).bind(this)
		this.goMahjong = (require("./goMahjong.js")).bind(this)


		//We don't want to rotate until the game is actually ended - otherwise, we mess up state if the game is reverted.
		//Therefore, we use a flag shouldRotateWinds. It defaults to true, and can be overridden by room.goMahjong
		this.shouldRotateWinds = true
		this.rotateWinds = function() {
			let winds = ["north", "east", "south", "west"].reverse()
			for (let clientId in this.state.settings.windAssignments) {
				let wind = this.state.settings.windAssignments[clientId]
				this.state.settings.windAssignments[clientId] = winds[(winds.indexOf(wind) + 1) % 4] //Next in order
			}
		}

		this.revertState = (function(client, turnNumber) {
			//Reverts state, returning to turn turnNumber
			turnNumber = Number(turnNumber)
			if (isNaN(turnNumber) || turnNumber < 0) {
				return client.message("roomActionGameplayAlert", "Revert Error: Invalid Revert turnNumber", "success")
			}
			this.messageAll([], "roomActionGameplayAlert", {format:"%(client)s reverted to move %(turn)s (%(move)s moves)", args:{client:this.getClientNickname(client.clientId), turn:turnNumber, move:this.state.moves.length - 1 - turnNumber}} )

			this.messageAll([], "roomActionRevertState") //Notifies client code about change - currently used to distinguish between charleston passes and reverts.

			this.delete()
			this.state.moves = this.state.moves.slice(0, turnNumber)
			let room = new Room(this.roomId, this.state)
			globalThis.serverStateManager.createRoom(this.roomId, room)
			room.init()
		}).bind(this)


		//Wait for all bots to receive and process state update. 
		//Place hold on state updates to players during that time. 
		//THEN send updated state. 

		//This is done to reduce the volume of state updates sent to players - there's no reason to send a state update for every bot move when
		//we could instead send only one state update. 
		let clientSendStatePaused = false;

		this.sendStateToClients = (function sendStateToClients() {
			let weChangedSendState = !clientSendStatePaused
			clientSendStatePaused = true 
			//Send state to bots first. Once bots have finished all actions, send states to clients.  
			this.clientIds.forEach((clientId) => {
				let client = globalThis.serverStateManager.getClient(clientId)
				if (client?.suppressed) {return false} //Optimize resuming games from state my not calling getState unnecessarily.
				if (client?.isBot) {
					let state = this.getState(clientId)
					client.message("roomActionState", state, "success")
				}
			})
			if (weChangedSendState) {clientSendStatePaused = false}

			if (!clientSendStatePaused) {
				// console.trace("Called")
				//Send to non-bots. 
				this.clientIds.forEach((clientId) => {
					let client = globalThis.serverStateManager.getClient(clientId)
					if (client?.suppressed) {return false} //Optimize resuming games from state my not calling getState unnecessarily.
					if (!client?.isBot) {
						let state = this.getState(clientId)
						client?.message("roomActionState", state, "success")
					}
				})
			}
		}).bind(this)

		this.computeNextName = (function(prefix) {
			//Find a name like prefix 1, prefix 2, etc. So Bot 1, Bot 2, Player 1, Player 2

			// let hostLocale = global.serverStateManager.getClient(this.hostClientId)?.locale
			let currentNames = this.clientIds.map((clientId) => {return this.getClientNickname(clientId)})
			for (let i=1;;i++) {
				//TODO: Translate names.
				//Complicated by no host locale at beginning.
				//So might want to store untranslated and translate on demand.

				let hostLocale = "en"
				let name = i18n.__n({singular: prefix + " %d", plural: prefix + " %d", locale: hostLocale, count:i})

				if (!currentNames.includes(name)) {
					return name
				}
			}
		}).bind(this)

		this.addClient = (function(clientId) {
			//If the client has no nickname, default assign.
			this.activityOccured()

			let client = globalThis.serverStateManager.getClient(clientId)

			if (this.clientIds.includes(clientId)) {return client.message("joinRoom", "Already In Room", "error")}

			if (!this.clientNicknames[clientId]) {
				this.setClientNickname(clientId, this.computeNextName(client.isBot ? "Bot":"Player"))
			}

			client.setRoomId(this.roomId)
			client.message("joinRoom", this.roomId, "success")

			if (!this.hostClientId) {this.hostClientId = clientId}
			this.clientIds.push(clientId)
			this.sendStateToClients()
			return true
		}).bind(this)

		this.messageAll = (function(exclude = [], ...args) {
			this.clientIds.forEach((clientId) => {
				if (exclude.includes(clientId)) {return}
				let client = globalThis.serverStateManager.getClient(clientId)
				client?.message(...args)
			})
		}).bind(this)

		this.endGame = (function endGame(obj, clientId) {
			this.closeLogFile()
			let gameEndMessage = "The Game Has Ended";
			if (clientId) {
				let client = globalThis.serverStateManager.getClient(clientId)
				//Tell players who ended the game.
				gameEndMessage = {format: "The game has been ended by %s.", args: this.getClientNickname(client.clientId)}
			}
			if (this.shouldRotateWinds) {this.rotateWinds()}
			this.shouldRotateWinds = true
			this.inGame = false
			delete this.state.seed
			delete this.state.wall
			//Without a seed, moves won't be evaluated, as no wall can be constructed.
			this.state.moves = []
			this.gameData = {}
			this.messageAll([clientId], obj.type, gameEndMessage, "success")
			this.sendStateToClients()
		}).bind(this)

		let placerMahjongOverride = false
		let placerSequenceOverride = false
		this.onPlace = (function(obj, clientId) {
			//Obj.message - a Tile, Match, or Sequence
			let move = [obj, clientId]
			//TODO: Now that bot moves should be deterministic, we no longer need to store the moves the bots made.
			//For American Mahjong, it probably still makes sense as it can take a bit of time to analyze the card.
			this.state.moves.push(move)
			this?.logFile?.write(JSON.stringify(move) + "\n")

			let client = globalThis.serverStateManager.getClient(clientId)
			let hand = this.gameData.playerHands[clientId]

			if (this.gameData.isMahjong) {

				return client.message("displayMessage", {title: "Mahjong!", body: this.lastSummary[client.locale]})
			}
			else if (this.gameData.wall.isEmpty) {

				return client.message("displayMessage", {title: "Game Over - Wall Empty", body: this.lastSummary[client.locale]})
			}

			if (!hand) {
				return client.message("displayMessage", {title: "Access Denied", body: "You are Spectating. "})
			}

			let turnChoicesAlreadyMade = Object.keys(this.gameData.currentTurn.turnChoices).length //Used to determine if we are the last player to make a choice, and therefore we don't need to send state updates (since turn switch will do so)

			let placement = obj?.message;
			try {
				if (placement === "Claim") {
					this.gameData.currentTurn.turnChoices[clientId] = placement
					return
				}
				placement = Hand.convertStringsToTiles(placement)

				if (this.state.settings.charleston.length > 0 && this.gameData.charleston === undefined && placement.length !== 1 && placement.length !== 4 && hand.wind === "east") {
					//In hand kongs are also possible at the start, hence the check for a length of 4.
					//I believe that one must charleston with in-hand-kongs (can't expose beforehand) if they are going to charleston.
					//However it is currently possible to charleston after placing an in hand kong - although the message changes
					//to the tile draw message (drawn tile from kong), placing 3 tiles afterwards still starts the charleston.
					if (placement.length === 3) {
						this.gameData.charleston = {
							directions: this.state.settings.charleston.slice(0)
						}

						let direction = this.gameData.charleston.directions[0][0].direction
						this.setAllInstructions([], {format:"Welcome to the Charleston. Select 3 tiles you would like to pass %s, then hit Proceed. ", argsI18n: direction} , "success")
						this.messageAll([clientId], "roomActionGameplayAlert", {format: "The first Charleston pass is %s", argsI18n: direction} , "success")
					}
					else if (!obj.mahjong) {
						return client.message(obj.type, "The very first throw must be either 1 tile, to initiate the game, or 3 tiles, to initiate charleston. ", "error")
					}
					else if (obj.mahjong) {
						placement = undefined
					}
				}
				else if (this.gameData.charleston) {}
				else if (placement.length > 1) {
					if (this.state.settings.gameStyle === "american") {
						//TileContainers bypass everything, which American Mahjong needs right now.
						placement = new TileContainer({tiles: placement})
					}
					else if (Match.isValidMatch(placement)) {
						placement = new Match({exposed: true, amount: placement.length, type: placement[0].type, value: placement[0].value})
					}
					else if (Sequence.isValidSequence(placement)) {
						placement = new Sequence({exposed: true, tiles: placement})
					}
					else if (placement.length === 2) {
						return client.message(obj.type, {format:["Your two selected tiles do not match, sequences require 3 tiles, and discards are a single tile. ", "Please review your selected tiles. "]}, "error")
					}
					else {
						return client.message(obj.type, {format:["Your selected tiles do not form a sequence or match, and discards are a single tile. ", "Please review your selected tiles. "]}, "error")
					}
				}
				else {
					placement = placement[0]
					this.gameData.charleston = this.gameData.charleston || false
				}
			}
			catch (e) {
				return client.message(obj.type, "Error: " + e.message, "error")
			}
			//The users wishes to place down tiles.
			//If it is not their turn, we will hold until all other players have either attempted to place or nexted.
			//Then we will apply priority.

			if (placement instanceof Array) {
				//This should only happen if we are in a charleston. Remove the charleston tiles from their hand.
				if (this.gameData.currentTurn.turnChoices[clientId]) {
					return client.message(obj.type, "You have already passed tiles for this charleston round. ", "error")
				}

				this.gameData.currentTurn.turnChoices[clientId] = placement
				//This should have been fixed elsewhere to no longer be necessary. 

				if (turnChoicesAlreadyMade !== 3) {
					this.sendStateToClients() //Send state update unless turn is going to change anyways. 
				} 
			}
			else if (this.gameData.currentTurn.thrown === false || this.gameData.currentTurn.thrown === undefined) {
				if (clientId !== this.gameData.currentTurn.userTurn) {
					//This player is not allowed to perform any actions at this stage.
					return client.message(obj.type, "Can't place after draw before throw", "error")
				}
				if (placement instanceof Tile) {
					if (obj.mahjong) {
						return client.message(obj.type, "You can't discard and go mahjong. ", "error")
					}

					if (hand.removeMatchingTilesFromHand(placement)) {
						//If this is the 4th tile for an exposed pong in this hand, we will turn it into a kong and draw another tile.
						//TODO: Note that it is remotely possible players will want to throw the 4th tile instead, as it is a very safe (if honor, entirely safe), throw.
						//This would mean sacraficing points and a draw in order to get a safe throw, and I have never seen it done, but there are scenarios where it may
						//actually be the best idea. We should probably allow this at some point.
						if (hand.contents.some(((item) => {
							if (item instanceof Match && item.type === placement.type && item.value === placement.value) {
								item.amount = 4
								this.drawTile(clientId)
								return true
							}
							return false
						}).bind(this))) {
							this.messageAll([clientId], "roomActionGameplayAlert", {format:"%s has upgraded an exposed pong into a kong", args:this.getClientNickname(client.clientId)}, {clientId, speech: "Make that a kong", durationMultiplier: 1.1}) //Add duation. Long speech.
							this.sendStateToClients()
							return;
						}

						if (obj.swapJoker) {
							//We're going to try to swap this discard out for a joker if possible.
							//Bots can pass true to auto-detect and not receive errors on fail.
							let clientIds;
							if (obj.swapJoker === true) {
								clientIds = [clientId].concat(this.clientIds) //This is 5 clientIds - but it doesn't matter since we'll short circuit.
							}
							else if (this.clientIds.indexOf(obj.swapJoker) !== -1) {
								clientIds = [obj.swapJoker]
							}
							else {
								return client.message(obj.type, "Unable to identify which player you want to swap with. ", "error")
							}

							let res = Object.keys(this.gameData.playerHands).some((clientId) => {
								let swapWithHand = this.gameData.playerHands[clientId]
								return swapWithHand?.contents?.some((item) => {
									if (item.exposed) {
										//In American Mahjong, the only tiles that can be called for are pongs, kongs, quints, and sextets.
										//Therefore, the jokers must match the other tiles exposed.
										let tile = item.tiles.find((tile) => {
											return tile.type !== "joker"
										})

										let jokerIndex = item.tiles.findIndex((tile) => {
											return tile.type === "joker"
										})

										if (jokerIndex !== -1 && tile.matches(placement)) {
											//Swap the joker for this tile
											hand.add(item.tiles[jokerIndex])
											item.tiles.splice(jokerIndex, 1)
											item.tiles.push(placement)
											return true
										}
									}
								})
							})

							if (res) {
								//Swapped for a joker
								this.lastDrawn = Tile.get({type: "joker"}) //Animate the joker (not the previous tile, if there was one).

								client.message("roomActionGameplayAlert", "Successfully Swapped", {clientId, speech: "Swapped", durationMultiplier: 0.5})
								this.messageAll([clientId], "roomActionGameplayAlert", this.getClientNickname(client.clientId) + " swapped a " + placement.getTileName(this.state.settings.gameStyle) + " for a joker", {clientId, speech: "Swap", durationMultiplier: 1})
								return this.sendStateToClients()
							}
							else {
								if (obj.swapJoker !== true) {
									hand.add(placement) //Restore the hand.
									//Couldn't swap - send error.
									return client.message(obj.type, "Could not find a joker to swap with. ", "error")
								}
							}
						}


						//Bots can pass true to auto-detect and not receive errors on fail.
						//Confirm this is either a bot or a normal discard - if a person fails to joker swap, we refund their tile.
						if (!obj.swapJoker || obj.swapJoker === true) {
							let tileObj = placement.toJSON()
							let tileName = placement.getTileName(this.state.settings.gameStyle) 	// until we revise speech
							let discardMessage = "%(client)s threw a %(tile)s"

							//We're also going to check if the discarder is calling.
							let durationMultiplier = 1;
							//TODO: Disabling isCalling would improve resume performance significantly (reduces time required by ~90%).
							//But it does prevent us from measuring time from calling to mahjong in statistics, etc.
							if (this.state.settings.checkForCalling && !hand.calling && hand.isCalling(this.gameData.discardPile, this.state.settings.maximumSequences)) {
								hand.calling = true
								discardMessage += ", and is calling"
								durationMultiplier = 1.5
							}

							//Discard tile.
							this.gameData.currentTurn.thrown = placement
							delete this.lastDrawn
							this.gameData.currentTurn.turnChoices[clientId] = "Next"
							placerMahjongOverride = false

							this.messageAll([clientId], "roomActionGameplayAlert", {format: discardMessage, args: {client: this.getClientNickname(client.clientId), tile:tileObj}, argsOption: {tile: localizeTileName} }, {clientId, speech: tileName, durationMultiplier, optional: !hand.calling})
							
							let instructionsComponent = "To skip, press Proceed. To claim this tile, select the tiles you are placing it with, and press Proceed (or Mahjong if this tile makes you Mahjong). "
							if (placement.type === "joker") {
								instructionsComponent = "To continue, press Proceed. Jokers are dead when thrown and cannot be claimed. "
							}

							this.setAllInstructions([clientId], {format: [discardMessage, ". ", instructionsComponent], args: {client:this.getClientNickname(client.clientId), tile:tileObj}, argsOption: {tile:localizeTileName} })

							client.addMessageToHistory({format: discardMessage.replace("is", "are"), args: {tile:tileObj}, argsI18n:{client:"You"}, argsOption:{tile: localizeTileName}}) //Make discards appear in history menu.

							this.sendStateToClients()
						}
					}
					else {
						return client.message(obj.type, "You can't place a tile you do not possess - try reloading the page or restarting the app", "error")
					}
				}
				else if (placement instanceof Match && placement.amount === 4) {
					if (obj.mahjong) {
						return client.message(obj.type, "You can't go mahjong while placing a kong. ", "error")
					}
					if (hand.removeMatchingTilesFromHand(placement.getComponentTile(), 4)) {
						//Place Kong. Turn remains the same, thrown false.
						hand.contents.push(placement)
						//This must be an in hand kong, therefore we do not expose, although in hand kongs will be shown.
						placement.exposed = false
						//Draw them another tile.
						this.drawTile(clientId)
						this.sendStateToClients()
						let placeMessage = "%(player)s placed an in-hand kong of %(tile)ss"
						let tileObj = placement.tiles[0].toJSON()

						this.messageAll([clientId], "roomActionGameplayAlert", {format:placeMessage, args:{player: this.getClientNickname(client.clientId), tile:tileObj}, argsOption:{tile:localizeTileName}}, {clientId, speech: "kong"})
						client.addMessageToHistory({format:placeMessage, args:{tile:tileObj}, argsI18n:{player:"You"}, argsOption:{tile:localizeTileName}})
						return
					}
					else {
						return client.message(obj.type, "You can't place tiles you do not possess - try reloading the page or restarting the app", "error")
					}
				}
				else if (obj.mahjong) {
					this.goMahjong(clientId, {drewOwnTile: !this.gameData.previousTurnPickedUp, override: placerMahjongOverride})
					if (!globalThis.serverStateManager.getClient(clientId).isBot) {
						placerMahjongOverride = true
					}
				}
				else if (!obj.mahjong && placement instanceof Match || placement instanceof Sequence) {
					return client.message(obj.type, "Can't expose in hand pong, sequence, or pair, except for mahjong.", "error")
				}
				else {
					//TODO: This triggers attempting to place an in hand sequence. This is the wrong error message, although it is an error.
					return client.message(obj.type, "Invalid placement attempt for current game status", "error")
				}
			}
			else if (placement === undefined) {
				if (this.gameData.charleston) {
					return globalThis.serverStateManager.getClient(clientId).message("roomActionPlaceTiles", "You must choose 3 tiles to pass during charleston. ", "error")
				}
				this.gameData.currentTurn.turnChoices[clientId] = "Next"

				if (turnChoicesAlreadyMade !== 3) {
					//Send update for all but last person to agree to proceed. 
					this.sendStateToClients()
				}
			}
			else {
				//This is not a discard, and it related to a throw, so must either be a pong, kong, sequence, or a pair if the user is going mahjong.
				if (obj.mahjong) {
					//Naked Mahjong
					placement.mahjong = obj.mahjong
				}
				else if (!(placement instanceof Match || placement instanceof Sequence || placement instanceof TileContainer)) {
					return client.message(obj.type, "You can't discard when it is not your turn", "error")
				}
				else if (placement instanceof Sequence && !placerSequenceOverride) {
					let sequenceCount = hand.contents.reduce((amount, item) => {
						if (item instanceof Sequence) {return ++amount}
						return amount
					}, 0)


					if (sequenceCount >= this.state.settings.maximumSequences) {
						placerSequenceOverride = true //TODO: We should probably turn this override off at some point.


						return client.message(obj.type, {format: ["Host game settings allow only %d sequence(s). ", "Repeat your same move to ignore this setting, and place this sequence. ", "Overriding this setting may cause minor issues in scoring, and may require a Mahjong override. "], args:this.state.settings.maximumSequences}, "error")
					}
				}

				//Schedule the order. It's validity will be checked later.
				this.gameData.currentTurn.turnChoices[clientId] = placement
				if (turnChoicesAlreadyMade !== 3) {
					this.sendStateToClients() //Update state unless turn going to change anyways. 
				}
			}
		}).bind(this)
	}

	maxInactivityTime = 1000 * 60 * 60 * 24 //24 hours

	activityOccured() {
		this.lastActivity = Date.now()
		this.checkForInactivity()
	}

	checkForInactivity() {
		//There seem to be crashes in the client.isBot on line 176 with client being undefined when this runs

		//We do not need to check for inactivity for offline games.
		if (!fs.createWriteStream) {return}

		clearTimeout(this.lastActivityTimeout)
		delete this.lastActivityTimeout

		let timeInactive = Date.now() - this.lastActivity
		let timeUntilClosed = this.maxInactivityTime - timeInactive
		let ratioTimeRemaining = timeUntilClosed / this.maxInactivityTime

		if (ratioTimeRemaining <= 0) {
			//Inactivity threshold met or exceeded. Close the room.
			while (this.clientIds.length > 0) {
				this.removeClient(this.clientIds[0], `Room closed due to inactivity (inactive for ${phraseTimeDuration(timeInactive)}). `)
			}
			this.delete()
			return;
		}
		else if (ratioTimeRemaining < 0.5) {
			//If we have used up more than half of inactivity time, alert user.
			this.messageAll([], "displayMessage", {title: "Room Inactive", body: `This room will be closed in ${phraseTimeDuration(timeUntilClosed)} due to inactivity (inactive for ${phraseTimeDuration(timeInactive)}). `})
		}

		let intervalRatio = 1/3 //The next check will be performed when this fraction of the current time remains - if 60 minutes left, 1/3rd means the next check is at 20 minutes left.
		let minimumInterval = 1000 * 60 //1 minute minimum interval.

		let timeBeforeNextCheck = Math.max(timeUntilClosed * (1 - intervalRatio), minimumInterval)
		this.lastActivityTimeout = setTimeout(this.checkForInactivity.bind(this), timeBeforeNextCheck)
	}

	setClientNickname(clientId, nickname) {
		if (nickname === undefined || nickname === "") {
			delete this.clientNicknames[clientId]
		}
		else {
			let newNickname = nickname.trim().slice(0, 14) //Limit nicknames to 14 characters.

			if (nickname.match(alphanumeric) === null) {
				//Nickname prohibited. 
				globalThis.serverStateManager.getClient(clientId)?.message("displayMessage", {title: "Invalid Nickname", body: "Nickname not allowed. Please use alphanumeric characters. "})
				return;
			}

			this.clientNicknames[clientId] = newNickname;
		}
	}

	getClientNickname(clientId) {
		return this.clientNicknames[clientId] || "NoName";
	}

	openLogFile() {
		//The below command is probably unnecessary (I don't believe there is any instance where openLogFile will be closed with a file open)
		//However it is here in case a log file is for some reason still open.
		this.closeLogFile()

		//Protect against path traversal with encodeURIComponent. 
		this.logFileSaveId = encodeURIComponent(this.roomId) + "-" + Date.now()

		let writeStream;

		//TODO: Should we gzip the file in the writestream? It would significant decrease file size (Use level 1 gzip for maximum speed - we could have lots of open handles)

		//globalThis.avoidFSWrites is a custom flag for special use cases like generating guaranteed hands.
		//Not used in normal conditions.


		//TODO: Check explicitly for path traversal! 
		//We prevent a security vulnerability as the room names are sanitized, and we use encodeURIComponent to avoid nasty characters,
		//but we still should have something here just in case those guarantees change at any point. 
		if (fs.createWriteStream && !globalThis.avoidFSWrites) {
			this.logFile = fs.createWriteStream(path.join(globalThis.serverStateManager.activeLogsDirectory, this.logFileSaveId + ".room"))
		}
		else {
			this.logFile = {
				write: function() {}
			}
		}
	}

	//End writestream.
	//Also relocate log file into directory for inactive logs.
	closeLogFile() {
		if (this.logFile?.end) {
			//Check this.logFile.end, as phony logfiles don't have an end method (and fs methods won't exist)
			this.logFile.end()
			let newPath = path.join(globalThis.serverStateManager.inactiveLogsDirectory, path.basename(this.logFile.path))
			fs.renameSync(this.logFile.path, newPath)
		}
		delete this.logFile
	}

	delete() {
		this.closeLogFile()
		globalThis.serverStateManager.deleteRoom(this.roomId)
	}

	toJSON() {
		let moves = this.state.moves
		delete this.state.moves
		let str = JSON.stringify(this.state)
		this.state.moves = moves
		str += "\n"
		this.state.moves.forEach((move) => {str += JSON.stringify(move) + "\n"})
		return str
	}

	//Files have the moves after - they aren't all in one place.
	static fromJSON(str) {
		let lines = str.trim().split("\n")
		let obj = JSON.parse(lines[0])
		let moves = lines.slice(1)
		moves = moves.map((str) => {return JSON.parse(str)})
		obj.moves = moves

		return new Room(obj.roomId, obj)
	}
}


module.exports = Room
